import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import Sidebar from "./Sidebar/Sidebar";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {
  // State to make navbar opaque, and to resize logo on scrolling
  const [navbackground, setnavbackground] = useState("transparent");
  const [logoSize, setlogoSize] = useState("1.8rem");

  // State to toggle sidebar open/close
  const [sidebarState, setsidebarState] = useState(false);
  useEffect(() => {
    document.addEventListener("scroll", () => {
      const navbg = window.scrollY < 100 ? "transparent" : "#000";
      const logosize = window.scrollY < 100 ? "1.8rem" : "1.5rem";
      setnavbackground(navbg);
      setlogoSize(logosize);
    });
  }, []);

  return (
    <div
      style={{
        backgroundColor: navbackground,
        transition: "all 0.1s ease-in-out",
      }}
      className="fixed w-full z-50 text-white h-24 flex items-center justify-between max-md:px-6 px-20 py-2"
    >
      <div
        style={{ fontSize: logoSize, transition: "all 0.1s ease-in-out" }}
        className="font-title tracking-wider"
      >
        <Link
          activeClass="active"
          to="home"
          spy={true}
          duration={500}
          smooth={true}
          className="cursor-pointer"
        >
          <div>
            Cryptogod <br></br> Anubis
          </div>
        </Link>
      </div>

      {/* Mobile sidebar */}
      <div className="hidden max-lg:block">
        <button
          onClick={() => {
            setsidebarState(true);
          }}
        >
          <GiHamburgerMenu
            className="hover:text-egyptian-gold transition-all ease-in-out duration-100"
            size="35px"
          />
        </button>
        <Sidebar
          sidebarState={sidebarState}
          updateSidebarState={setsidebarState}
        />
      </div>

      {/* Desktop Navbar links */}
      <div className="font-content max-lg:hidden lg:text-base w-7/12 flex items-baseline justify-evenly">
        <Link
          activeClass="active"
          to="home"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          Home
        </Link>
        <Link
          activeClass="active"
          to="about"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          About Us
        </Link>
        <Link
          activeClass="active"
          to="roadmap"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          Roadmap
        </Link>
        <Link
          activeClass="active"
          to="faq"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          FAQ
        </Link>
        <Link
          activeClass="active"
          to="mint"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          How to Mint
        </Link>
        <Link
          activeClass="active"
          to="team"
          spy={true}
          duration={500}
          smooth={true}
          className="hover:text-egyptian-gold transition-all duration-200 cursor-pointer"
        >
          Team
        </Link>
        <Link
          activeClass="active"
          to="social"
          spy={true}
          duration={500}
          smooth={true}
          className="bg-white hover:bg-egyptian-gold transition-all text-black px-4 ease-in-out duration-200 cursor-pointer rounded-full"
        >
          Join Us
        </Link>
      </div>
    </div>
  );
};
export default Navbar;
